import React from "react";
import SectionTitle from "../../UI/SectionTitle";
import SlickSlider from "../../UI/Slick";
import Founders from "./Founders";

import teamBg from "../../../assets/img/bg-blog.jpg";
import ourJourney from "../../../assets/img/road-map-horizontal3.jpg";
import founderData from "../../../data/Founders/founders.json";

function Team() {
  return (
    <div
      className="team-area-wrapper journey-area-wrapper bg-img sp-y"
      style={{ backgroundImage: `url(${teamBg})` }}
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-12 text-center">
            <SectionTitle
              variant="light"
              title="OUR JOURNEY"
              heading=""
              text=""
              // image={require("../../../assets/img/separator7.svg")}
              titleTag="h1"
            />
            {/* <div className="col-lg-12">
              <SlickSlider settings={settings}>
                {founderData.map((team) => (
                  <div key={team.id}>
                    <Founders
                      id={team.id}
                      text={team.text}
                      image={team.image}
                      name={team.name}
                      link={team.link}
                    />
                  </div>
                ))}
              </SlickSlider>
            </div> */}

            <div className="founder-item-container">
              <img
                src={ourJourney}
                alt="Our Journey | Kangaroo Care Hospitals"
              />
            </div>
          </div>
        </div>

        {/* <div
          className=" col-lg-10 m-auto m-5 p-4 "
          style={{
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
        >
          <p
            className="py-2"
            style={{
              color: "#000",
              fontSize: "20px",
              fontWeight: "300",
            }}
          >
            At Kangaroo Care, we recognize the emotions, anticipation, and care
            involved in the journey of welcoming a new life. With years of
            dedicated service, we’ve built a legacy of excellence in maternity
            care, ensuring that every family receives the support and healthcare
            they deserve.
          </p>
          <p
            className="py-2"
            style={{
              color: "#000",
              fontSize: "20px",
              fontWeight: "300",
            }}
          >
            With branches across Bangalore, Mysore, Ramanagara, and Tumkur, we
            take pride in having supported thousands of healthy newborns and
            joyful families.
          </p>
          <p
            className="py-2"
            style={{
              color: "#000",
              fontSize: "20px",
              fontWeight: "300",
            }}
          >
            Our growing list of recognitions and awards reflects not only our
            medical expertise but also the compassion and personal care we bring
            to every moment.
          </p>
          <p
            className="py-2"
            style={{
              color: "#000",
              fontSize: "20px",
              fontWeight: "300",
            }}
          >
            As you prepare for this beautiful chapter, Kangaroo Care is
            committed to making your experience safe, memorable, and truly
            special.
          </p>
        </div> */}
      </div>
    </div>
  );
}

export default Team;
